import Vue from 'vue'
import Router from 'vue-router'
import util from "../common/js/util";
import store from 'store/store'
import * as commonType from 'store/type'
import * as nativeType from 'common/js/nativeType'

Vue.use(Router)

//路由配置
const Routers = [
    {
        path: '/',
        meta: {
            //title: '首页',
            title: '京东万商',
            keepAlive: true,
            isFirstLevelPage: true //是否是一级页面
        },
        name: 'index',
        component: (resolve) => require(['../components/index/index.vue'], resolve)
    },
    /*{
        path: '/',
        meta: {
            title: '首页',
            keepAlive: true
        },
        name: 'index',
        component: (resolve) => require(['../components/index/index.vue'], resolve)
        //component: aboutUs
    },*/
    {
        path: '/notLogin',
        meta: {
            //title: '首页'
            title: '京东万商',
            keepAlive: true
        },
        name: 'notLogin',
        component: (resolve) => require(['../components/about-us/about-us.vue'], resolve)
    },
    {
        path: '/loadingPage',
        meta: {
            title: '京东万商',
            keepAlive: true
        },
        name: 'loadingPage',
        component: (resolve) => require(['../components/loading-page/loading-page.vue'], resolve)
    },
    {
        path: '/bulletinDetail',
        meta: {
            title: '快报详情',
            keepAlive: true,
            isHideHeader: true
        },
        name: 'bulletinDetail',
        component: (resolve) => require(['../components/bulletin-detail/bulletin-detail.vue'], resolve)
    },
    {
        path: '/errorPage',
        meta: {
            title: '错误页'
        },
        name: 'errorPage',
        component: (resolve) => require(['../components/error/error.vue'], resolve)
    },
    {
        path: '/searchList',
        meta: {
            //title: '搜索列表页',
            title: '搜索页',
            keepAlive: true
        },
        name: 'searchList',
        component: (resolve) => require(['../components/search-list/search-list.vue'], resolve)
    },
    {
        path: '/classList',
        meta: {
            //title: '搜索列表页',
            title: '分类',
            keepAlive: true,
            isFirstLevelPage: true
        },
        name: 'classList',
        component: (resolve) => require(['../components/class-list/class-list.vue'], resolve)
    },
    {
        path: '/productDetail',
        meta: {
            title: '商品',
            keepAlive: false
        },
        name: 'productDetail',
        component: (resolve) => require(['../components/product-detail/product-detail.vue'], resolve)
    },
    {
        path: '/productDetailShare',
        meta: {
            title: '商品',
            keepAlive: false
        },
        name: 'productDetailShare',
        component: (resolve) => require(['../components/product-detail/product-detail-share.vue'], resolve)
    },
    {
        path: '/productDetailInfo',
        meta: {
            title: '商品详情',
            keepAlive: true
        },
        name: 'productDetailInfo',
        component: (resolve) => require(['../components/product-detail/product-detail-info.vue'], resolve)
    },
    {
        path: '/confirm',
        meta: {
            title: '填写采购单',
            keepAlive: true
        },
        name: 'confirm',
        component: (resolve) => require(['../components/confirm/confirm.vue'], resolve)
    },
    {
        path: '/productList',
        meta: {
            //title: '商品清单',
            title: '采购商品列表',
            keepAlive: true
        },
        name: 'productList',
        component: (resolve) => require(['../components/confirm/product-list.vue'], resolve)
    },
    {
        path: '/payDist',
        meta: {
            title: '支付配送'
        },
        name: 'payDist',
        component: (resolve) => require(['../components/confirm/pay-dist.vue'], resolve)
    },
    {
        path: '/invoice',
        meta: {
            title: '发票信息'
        },
        name: 'invoice',
        component: (resolve) => require(['../components/confirm/invoice.vue'], resolve)
    },
    {
        path: '/register',
        component: (resolve) => require(['../components/register/register.vue'], resolve),
        children: [
            {
                path: '',
                meta: {
                    title: '企业类型',
                    keepAlive: false
                },
                name: 'companyType',
                component: (resolve) => require(['../components/register/company-type/company-type.vue'], resolve)
            },
            {
                path: 'companyType',
                meta: {
                    title: '企业类型',
                    keepAlive: false
                },
                name: 'companyType',
                component: (resolve) => require(['../components/register/company-type/company-type.vue'], resolve)
            },
            {
                path: 'companyInfo',
                meta: {
                    title: '企业信息',
                    keepAlive: false //所在地区存在问题
                },
                name: 'companyInfo',
                component: (resolve) => require(['../components/register/company-info/company-info.vue'], resolve)
                //component: companyInfo
            },
            {
                path: 'legalInfo',
                meta: {
                    title: '法人信息',
                    keepAlive: false
                },
                name: 'legalInfo',
                component: (resolve) => require(['../components/register/legal-info/legal-info.vue'], resolve)
                //component: legalInfo
            },
            {
                path: 'fillQualify',
                meta: {
                    title: '品类完善',
                    keepAlive: false
                },
                name: 'fillQualify',
                component: (resolve) => require(['../components/register/fill-qualify/fill-qualify.vue'], resolve)
                //component: fillQualify
            }
        ]
    },
    {
        path: '/audit',
        meta: {
            title: '提交审核',
            keepAlive: false //有缓存后页面倒计时有问题，这个页面没必要缓存
        },
        name: 'audit',
        component: (resolve) => require(['../components/audit/audit.vue'], resolve)
    },
    {
        path: '/personalCenter',
        meta:{
            title: '个人中心',
            keepAlive: true,
            isFirstLevelPage: true
        },
        name: 'personalCenter',
        component: (resolve) => require(['../components/personal-center/personal-center.vue'], resolve)
    },
    {
        path: '/setting',
        meta:{
            title: '设置',
            keepAlive: true
        },
        name:'setting',
        component: (resolve) => require(['../components/setting/setting.vue'], resolve)
    },
    {
        path: '/companyInfo',
        meta:{
            title: '企业信息',
            keepAlive: true
        },
        name:'companyInfo',
        component: (resolve) => require(['../components/setting/company-info/company-info.vue'], resolve)
    },
    {
        path: '/qualificationInfo',
        meta:{
            title: '资质信息',
            keepAlive: true
        },
        name:'qualificationInfo',
        component: (resolve) => require(['../components/setting/qualification-info/qualification-info.vue'], resolve)
    },
    {
        path: '/corporationInfo',
        meta:{
        title: '法人信息',
            keepAlive: true
        },
        name:'corporationInfo',
        component: (resolve) => require(['../components/setting/corporation-info/corporation-info.vue'], resolve)
    },
    {
        path: '/vatInfo',
        meta:{
            title: '增票资质',
            keepAlive: true,
            isHideHeader: true
        },
        name:'vatInfo',
        component: (resolve) => require(['../components/setting/vat-info/vat-info.vue'], resolve)
    },
    {
        path: '/vatForm',
        meta:{
            title: '新增增票信息',
            keepAlive: true,
            isHideHeader: true
        },
        name:'vatForm',
        component: (resolve) => require(['../components/setting/vat-info/vat-manage/vat-form.vue'], resolve)
    },
    {
        path: '/deliveryAddressForm',
        meta:{
            title: '新增收票地址',
            keepAlive: false,
            isHideHeader: true
        },
        name:'deliveryAddressForm',
        component: (resolve) => require(['../components/setting/vat-info/delivery-address/delivery-address-form.vue'], resolve)
    },
    {
        path: '/settlementInfo',
        meta:{
            title: '结算信息',
            keepAlive: true,
            isHideHeader: true
        },
        name:'settlementInfo',
        component: (resolve) => require(['../components/setting/settlement-info/settlement-info.vue'], resolve)
    },
    {
        path: '/refundInfo',
        meta:{
            title: '退款信息',
            keepAlive: true,
            isHideHeader: true
        },
        name:'refundInfo',
        component: (resolve) => require(['../components/setting/refund-info/refund-info.vue'], resolve)
    },
    {
        path: '/refundForm',
        meta:{
            title: '编辑退款信息',
            keepAlive: true,
            isHideHeader: true
        },
        name:'refundForm',
        component: (resolve) => require(['../components/setting/refund-info/refund-form.vue'], resolve)
    },
    {
        path: '/electProtocol',
        meta:{
            title: '京东分销平台用户注册协议',
            keepAlive: false
        },
        name: 'electProtocol',
        component: (resolve) => require(['../components/elect-protocol/elect-protocol.vue'], resolve)
    },
    {
        path: '/baseInfo',
        meta:{
            title: '基础信息',
            keepAlive: false
        },
        name:'baseInfo',
        component: (resolve) => require(['../components/setting/base-info/base-info.vue'], resolve)
    },
    {
        path: '/sellerInfo',
        meta:{
            title: '卖家信息',
            keepAlive: true
        },
        name:'sellerInfo',
        component: (resolve) => require(['../components/setting/seller-info/seller-info.vue'], resolve)
    },
    {
        path: '/saleCategory',
        meta:{
            title: '售卖品类',
            keepAlive: true
        },
        name:'saleCategory',
        component: (resolve) => require(['../components/setting/seller-info/sale-category.vue'], resolve)
    },
    {
        path: '/addCategory',
        meta:{
            title: '卖家申请',
            keepAlive: false  //此页面可能是子组件
        },
        name:'addCategory',
        component: (resolve) => require(['../components/setting/seller-info/add-category.vue'], resolve)
    },
    {
        path: '/sellerEnterProtocol',
        meta:{
            title: '京东万商卖家入驻协议',
            keepAlive: true
        },
        name:'sellerEnterProtocol',
        component: (resolve) => require(['../components/setting/seller-info/seller-enter-protocol.vue'], resolve)
    },
    {
        path: '/sellerLicenceInfo',
        meta:{
            title: '证照信息',
            keepAlive: true
        },
        name:'sellerLicenceInfo',
        component: (resolve) => require(['../components/setting/seller-info/seller-licence-info.vue'], resolve)
    },
    {
        path: '/addressList',
        meta:{
            title: '地址列表',
            // title: '收货地址',
            keepAlive: true
        },
        name:'addressList',
        component: (resolve) => require(['../components/setting/address-manage/address-list.vue'], resolve)
    },
    {
        path: '/addressForm',
        meta:{
            //title: '新增/编辑地址',
            title: '新增地址',
            keepAlive: false //所在地区存在问题
        },
        name:'addressForm',
        component: (resolve) => require(['../components/setting/address-manage/address-form.vue'], resolve)
    },
    {
        path: '/purchaseOrder',
        meta:{
            title: '我的采购单',
            keepAlive: false
        },
        name:'purchaseOrder',
        component: (resolve) => require(['../components/purchase-order/purchase-order.vue'], resolve)
    },
    {
        path: '/checkPurchaseOrder',
        meta:{
            title: '审核采购单',
            keepAlive: true
        },
        name:'checkPurchaseOrder',
        component: (resolve) => require(['../components/purchase-order/check-purchase-order.vue'], resolve)
    },
    {
        path: '/purchaseOrderDetail',
        meta:{
            title: '采购单详情',
            keepAlive: true
        },
        name:'purchaseOrderDetail',
        component: (resolve) => require(['../components/purchase-order/purchase-order-detail.vue'], resolve)
    },
    {
        path: '/myOrder',
        meta:{
            title: '我的订单',
            keepAlive: false
        },
        name:'myOrder',
        component: (resolve) => require(['../components/my-order/my-order.vue'], resolve)
    },
    {
        path: '/confirmDelivery',
        meta:{
            title: '配送地址',
            keepAlive: false
        },
        name:'confirmDelivery',
        component: (resolve) => require(['../components/my-order/confirm-delivery.vue'], resolve)
    },
    {
        path: '/weixinPay',
        meta:{
            title: '',
            keepAlive: false
        },
        name:'weixinPay',
        component: (resolve) => require(['../components/my-order/weixin-pay.vue'], resolve)
    },
    {
        path: '/androidPay',
        meta:{
            title: '支付跳转中',
            keepAlive: false
        },
        name:'androidPay',
        component: (resolve) => require(['../components/my-order/android-pay.vue'], resolve)
    },
    {
        path: '/orderDetail',
        meta:{
            title: '订单详情',
            keepAlive: true
        },
        name:'orderDetail',
        component: (resolve) => require(['../components/my-order/order-detail.vue'], resolve)
    },
    {
        path: '/stockOut',
        meta:{
            title: '订单出库',
            keepAlive: true
        },
        name:'stockOut',
        component: (resolve) => require(['../components/my-order/stock-out.vue'], resolve)
    },
    {
        path: '/deliveryService',
        meta:{
            title: '快递服务',
            keepAlive: false
        },
        name:'deliveryService',
        component: (resolve) => require(['../components/my-order/delivery-service.vue'], resolve)
    },
    {
        path: '/pickup',
        meta:{
            title: '京东快递',
            keepAlive: true
        },
        name:'pickup',
        component: (resolve) => require(['../components/my-order/pickup.vue'], resolve)
    },
    {
        path: '/prtSubCompany',
        meta:{
            title: '',
            keepAlive: false
        },
        name:'prtSubCompany',
        component: (resolve) => require(['../components/setting/prt-sub-company/prt-sub-company.vue'], resolve)
    },
    {
        path: '/parentCompany',
        meta:{
            title: '新增/变更服务商',
            keepAlive: true
        },
        name:'parentCompany',
        component: (resolve) => require(['../components/setting/prt-sub-company/parent-company.vue'], resolve)
    },
    {
        path: '/logisticDetail',
        meta:{
            title: '物流详情',
            keepAlive: true
        },
        name:'logisticDetail',
        component: (resolve) => require(['../components/my-order/logistic-detail.vue'], resolve)
    },
    {
        path: '/shoppingCart',
        meta:{
	        title: '采购车',
            keepAlive: true,
            isFirstLevelPage: true
        },
        name:'shoppingCart',
        component: (resolve) => require(['../components/shopping-cart/shopping-cart.vue'], resolve)
    },
    {
        path: '/confirmSuc',
        meta:{
            title: '采购单提交完成',
            keepAlive: true
        },
        name:'confirmSuc',
        component: (resolve) => require(['../components/confirm-suc/confirm-suc.vue'], resolve)
    },
    {
        path: '/paySuc',
        meta:{
            //title: '支付成功',
            title: '订单支付成功',
            keepAlive: true
        },
        name:'paySuc',
        component: (resolve) => require(['../components/pay-suc/pay-suc.vue'], resolve)
    },
    {
        path: '/spellBuyDetail',
        meta:{
            title: '拼购详情页',
            keepAlive: true
        },
        name:'spellBuyDetail',
        component: (resolve) => require(['../components/spell-buy/spell-buy-detail/spell-buy-detail.vue'], resolve)
    },
    {
        path: '/toAccount',
        meta:{
            title: '填写采购单',
            keepAlive: true
        },
        name:'toAccount',
        component: (resolve) => require(['../components/spell-buy/spell-buy-settlement/spell-buy-settlement.vue'], resolve)
    },
    {
        path: '/spellBuySuc',
        meta:{
            title: '拼购订单提交完成',
            keepAlive: true
        },
        name:'spellBuySuc',
        component: (resolve) => require(['../components/spell-buy/spell-buy-suc/spell-buy-suc.vue'], resolve)
    },
    {
        path: '/createWare',
        component: (resolve) => require(['../components/create-ware/create-ware.vue'], resolve),
        children: [
            {
                path: '',
                meta: {
                    title: '新建商品',
                    keepAlive: true
                },
                name: '',
                component: (resolve) => require(['../components/create-ware/base-info.vue'], resolve)
            },
            {
                path: 'baseInfo',
                meta: {
                    title: '新建商品',
                    keepAlive: true
                },
                name: 'wareBaseInfo',
                component: (resolve) => require(['../components/create-ware/base-info.vue'], resolve)
            },
            {
                path: 'setPriceStock',
                meta: {
                    title: '新建商品',
                    keepAlive: true
                },
                name: 'setPriceStock',
                component: (resolve) => require(['../components/create-ware/set-price-stock.vue'], resolve)
            }
        ]
    },
    {
        path: '/setAttrs',
        meta:{
            title: '设置销售属性',
            keepAlive: true
        },
        name:'setAttrs',
        component: (resolve) => require(['../components/create-ware/set-attrs.vue'], resolve)
    },
    {
        path: '/previewWare',
        meta:{
            title: '预览商品详情',
            keepAlive: true
        },
        name:'previewWare',
        component: (resolve) => require(['../components/create-ware/preview-ware.vue'], resolve)
    },
    {
        path: '/checkoutCounter',
        meta:{
            title: '收银台',
            keepAlive: false
        },
        name:'checkoutCounter',
        component: (resolve) => require(['../components/my-order/checkout-counter.vue'], resolve)
    },
    {
        path: '/message',
        meta:{
            title: '消息',
            keepAlive: true
        },
        name:'message',
        component: (resolve) => require(['../components/message/message.vue'], resolve)
    },
    {
        path: '/invoiceManage',
        meta:{
            title: '开票管理',
            keepAlive: true
        },
        name:'invoiceManage',
        component: (resolve) => require(['../components/invoice-manage/invoice-manage.vue'], resolve)
    },
    {
        path: '/invoiceDetail',
        meta:{
            title: '开票详情',
            keepAlive: true
        },
        name:'invoiceDetail',
        component: (resolve) => require(['../components/invoice-manage/invoice-detail.vue'], resolve)
    },
    {
        path: '/invoiceLogisticDetail',
        meta:{
            title: '物流详情',
            keepAlive: true
        },
        name:'invoiceLogisticDetail',
        component: (resolve) => require(['../components/invoice-manage/invoice-logistic-detail.vue'], resolve)
    },
    {
        path: '/aboutUs',
        meta:{
            title: '关于京东万商',
            keepAlive: true,
            isHideHeader: true
        },
        name:'aboutUs',
        component: (resolve) => require(['../components/setting/about-us/about-us.vue'], resolve)
    },
    {
        path: '/privacyPolicy',
        meta:{
            title: '隐私政策',
            keepAlive: true,
            isHideHeader: true
        },
        name:'privacyPolicy',
        component: (resolve) => require(['../components/setting/about-us/privacy-policy.vue'], resolve)
    },
    {
        path: '/dongdong',
        meta:{
            title: '',
            keepAlive: true
        },
        name:'dongdong',
        component: (resolve) => require(['../components/dongdong/dongdong.vue'], resolve)
    },
    {
        path: '/productLineList',
        meta:{
            title: '我的产品线',
            keepAlive: true,
            isFirstLevelPage: true
        },
        name:'productLineList',
        component: (resolve) => require(['../components/product-line/product-line-list.vue'], resolve)
    },
    {
        path: '/pLineProduct',
        meta:{
            title: '',
            keepAlive: true
        },
        name:'pLineProduct',
        component: (resolve) => require(['../components/product-line/p-line-product.vue'], resolve)
    },
    {
        path: '/myBean',
        meta:{
            title: '我的京采豆',
            keepAlive: true,
            isHideHeader: true
        },
        name:'myBean',
        component: (resolve) => require(['../components/my-bean/my-bean.vue'], resolve)
    },
    {
        path: '/beanDetail',
        meta:{
            title: '京采豆明细',
            keepAlive: true,
            isHideHeader: true
        },
        name:'beanDetail',
        component: (resolve) => require(['../components/my-bean/bean-detail.vue'], resolve)
    },
    {
        path: '/beanPolicy',
        meta:{
            title: '京采豆规则',
            keepAlive: true,
            isHideHeader: true
        },
        name:'beanPolicy',
        component: (resolve) => require(['../components/my-bean/bean-policy.vue'], resolve)
    },
    {
        path: '/safariPage',
        meta:{
            title: '',
            keepAlive: false
        },
        name:'safariPage',
        component: (resolve) => require(['../components/base/safari-page/safari-page.vue'], resolve)
    },
    {
        path: '/walletProtocol',
        meta:{
            title: '京东钱包服务协议',
            keepAlive: false
        },
        name: 'walletProtocol',
        component: (resolve) => require(['../components/wallet-protocol/wallet-protocol.vue'], resolve)
    },
    {
        path: '/financePrivacyProtocol',
        meta:{
            title: '京东金融隐私政策',
            keepAlive: false
        },
        name: 'financePrivacyProtocol',
        component: (resolve) => require(['../components/wallet-protocol/finance-privacy-protocol.vue'], resolve)
    },
    {
        path: '/wuquanProtocol',
        meta:{
            title: '物权转移交付须知',
            keepAlive: false
        },
        name: 'wuquanProtocol',
        component: (resolve) => require(['../components/wuquan-protocol/wuquan-protocol.vue'], resolve)
    },
    {
        path: '/limitSaleManage',
        meta:{
            title: '限购管理',
            keepAlive: false
        },
        name:'limitSaleManage',
        component: (resolve) => require(['../components/limit-sale/limit-sale-manage.vue'], resolve)
    },
    {
        path: '/limitSetting',
        meta:{
            title: '限购设置',
            keepAlive:  false     //必须设置为true,不然选择限购商品列表后返回到限购设置，之前填写的数据会被清空。但是keepAlive为true时需要处理前后切换关系
                                  //可以设置为false，将列表数据放置到vuex管理，这样用户再未提交之前，数据都暂存在vuex里，当提交成功后，将vuex数据清空
        },
        name:'limitSetting',
        component: (resolve) => require(['../components/limit-sale/limit-setting.vue'], resolve)
    },
    {
        path: '/wareLists',
        meta:{
            title: '商品列表',
            keepAlive: true     //必须设置为true，因为带翻页，要暂存用户上次的选择，以便用户新增时再次修改
        },
        name:'wareLists',
        component: (resolve) => require(['../components/limit-sale/ware-lists.vue'], resolve)
    },
    {
        path: '/letterList',
        meta:{
            title: '消息列表',
            keepAlive: true,
            isHideHeader: true
        },
        name: 'letterList',
        component: (resolve) => require(['../components/letter/letter-list'], resolve)
    },
    {
        path: '/letterDetail',
        meta:{
            title: '站内信详情',
            keepAlive: true,
            isHideHeader: true
        },
        name: 'letterDetail',
        component: (resolve) => require(['../components/letter/letter-detail'], resolve)
    },
    {
        path: '/orderCancelProgress',
        meta:{
            title: '取消进度',
            keepAlive: true
        },
        name: 'orderCancelProgress',
        component: (resolve) => require(['../components/my-order/order-cancel-progress'], resolve)
    },
    {
        path: '/brandList',
        meta:{
            title: '品牌直通车',
            keepAlive: true
        },
        name: 'brandList',
        component: (resolve) => require(['../components/brand/brand-list'], resolve)
    },
    {
        path: '/privacyList',
        meta:{
            title: '隐私政策简要版',
            keepAlive: false
        },
        name:'privacyList',
        component: (resolve) => require(['../components/setting/privacy-list/privacy-list.vue'], resolve)
    },
    {
        path: '/appDownload',
        meta:{
            title: '京东万商APP下载页',
            keepAlive: true
        },
        name:'appDownload',
        component: (resolve) => require(['../components/app-download/app-download.vue'], resolve)
    },
    {
        path: '/androidDownload',
        meta:{
            title: '京东万商APP下载页',
            keepAlive: true
        },
        name:'androidDownload',
        component: (resolve) => require(['../components/app-download/android-download.vue'], resolve)
    },
    {
        path: '/agentPurchaseList',
        meta:{
            title: '代下单数据',
            keepAlive: false,
            isHideHeader: true
        },
        name:'agentPurchaseList',
        component: (resolve) => require(['../components/agent-purchase-list/agent-purchase-list.vue'], resolve)
    },
];
const RouterConfig = {
    routes: Routers,
    // scrollBehavior (to, from, savedPosition) {
    //     console.log(savedPosition);
    //     if (savedPosition) {
    //         return savedPosition
    //     } else {
    //         return { x: 0, y: 0 }
    //     }
    // }
};

const router = new Router(RouterConfig);

// 解决上面跳转加参数报错问题 处理Error: Redirected when going from "/" to "/bulletinDetail" via a navigation guard
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};

// // 修改路由replace方法,阻止重复点击报错
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};

const whiteList = ['notLogin', 'electProtocol', 'bulletinDetail', 'loadingPage', 'sellerEnterProtocol',
    'paySuc', 'aboutUs', 'privacyPolicy', 'dongdong', 'safariPage', 'walletProtocol',
    'financePrivacyProtocol', 'productDetailInfo', 'productDetailShare', 'letterList',
    'privacyList', 'appDownload', 'androidDownload'];

router.beforeEach((to, from, next) => {
    //设置当前页面是否是一级页面
    if(to.meta.isFirstLevelPage){
        store.commit(commonType.SET_IS_FIRST_LEVEL_PAGE, true);
    }else{
        store.commit(commonType.SET_IS_FIRST_LEVEL_PAGE, false);
    }
    //APP回退处理
    window.isFirstPage = ()=>{
        const firstPageNames = ['index','classList','shoppingCart','personalCenter'];
        let flag = firstPageNames.indexOf(to.name) > -1 ? true : false;
        let getData = {
            "businessType" 	: 'back',
            "params" 		: {
                "key": flag
            }
        };
        window.JDWebView && window.JDWebView.asyncToNative(JSON.stringify(getData));
    }
    next()
});

//轮询器和清除轮询器的timer
let listener = null, timer = null;

//处理掉header第一个兄弟结点的margin-top
const dealHeader = () => {
    //设置轮询（因为此时可能还没有加载返回头）设置返回头下面元素的marginTop
    listener = setInterval(()=>{
        const ele = document.querySelector('.m-header + *')
        if(ele) {
            clearInterval(listener)
            clearTimeout(timer)
            ele.style.marginTop = 0;
            const tabElem = ele.querySelector('.tab');
            if(tabElem){
                tabElem.style.marginTop = 0;
            }
        }
    },50)

    //30s后清除轮询器，避免一直轮询
    timer = setTimeout(() => {
        clearInterval(listener)
        listener = null
    }, 30000)
}

router.afterEach((to, from) => {
    // img为各个页面查看图片详情的路径
    if (!whiteList.includes(to.name) && to.path.indexOf("/img") < 0
            && !(to.name == 'spellBuyDetail' && (to.query.share == 1 || to.query.share == 2))) {
        //非注册页、预览大图、未登陆首页、设置、协议、快报详情、loading页面、卖家入驻协议、提交审核、支付成功页、关于我们、
        // 隐私政策、分享中间页、京东钱包协议，京东金融隐私政策，从分享链接或者唤起app点击进入的拼购详情不查询、商品详情页下面的商品详情、消息列表
        util.post({
            params: {
                functionId: 'businessUserInfo'
            },
            sc(res) {
                store.commit(commonType.SET_USER_INFO, res.data);
                store.commit(commonType.SET_USER_TYPE, res.data.tpuser);
                store.commit(commonType.SET_USER_STATE, res.data.state); //保存用户状态信息
                store.commit(commonType.SET_USER_MAIL, res.data.mail); //保存用户邮箱
                store.commit(commonType.SET_USER_IDENTITY, res.data.userGroupIdentity || 3); //保存用户身份信息
            }
        });
    }

    if(to.name == 'searchList'){
        if(from.name == 'classList' && !to.query.keyword){
            to.meta.title = "分类结果页";
        }else{
            to.meta.title = "搜索结果页";
        }
    }
    //处理新增和编辑地址标题
    if(to.name == 'addressForm' && to.query.id){
        to.meta.title = "编辑地址";
    }else if(to.name == 'addressForm' && !to.query.id){
        to.meta.title = "新增地址";
    }

    //处理新增、查看和编辑退款信息标题
    if(to.name == 'refundForm' && to.query.id && to.query.type == 1){
        to.meta.title = "查看退款信息";
    }else if(to.name == 'refundForm' && to.query.id && to.query.type == 2){
        to.meta.title = "编辑退款信息";
    }else if(to.name == 'refundForm' && !to.query.id){
        to.meta.title = "新增退款信息";
    }

    //处理新增、查看和编辑收票地址信息标题
    if(to.name == 'deliveryAddressForm' && to.query.id && to.query.type == 1){
        to.meta.title = "查看收票地址";
    }else if(to.name == 'deliveryAddressForm' && to.query.id && to.query.type == 2){
        to.meta.title = "编辑收票地址";
    }else if(to.name == 'deliveryAddressForm' && !to.query.id){
        to.meta.title = "新增收票地址";
    }

    //处理新增、查看和编辑增票信息标题
    if(to.name == 'vatForm'){
        to.meta.title = to.query.type == 0 ? '新增增票信息' : to.query.type == 1 ? '编辑增票信息' : '查看增票信息';
    }

    //处理新增和编辑商品标题
    if(to.name == 'wareBaseInfo' || to.name == 'setPriceStock'){
        to.meta.title = to.query.fromWhere == 1 ? '新建商品' : '编辑商品';
    }

    //处理提单成功页标题
    if(to.name == 'confirmSuc'){
        let ret = to.query.isAutoAudit;
        if((ret && ret.toString() === 'true') || router.app.$store.state.tpUser){
            to.meta.title = '订单提交完成';
        }else{
            to.meta.title = '采购单提交完成';
        }
    }

    //隐私
    if(to.name == 'privacyList' && to.query.source == 1){
        to.meta.title = "隐私政策简要版";
    }else if(to.name == 'privacyList' && to.query.source == 2){
        to.meta.title = "个人信息收集清单";
    }else if(to.name == 'privacyList' && to.query.source == 3){
        to.meta.title = "应用权限说明";
    }else if(to.name == 'privacyList' && to.query.source == 4){
        to.meta.title = "个人信息共享清单";
    }

	/* 路由发生变化时修改页面title */
	if (to.meta.title) {
		document.title = to.meta.title;
	}
	let toastElems = document.getElementsByClassName("nut-toast");
	if(toastElems.length > 0){ //删除最近展示的浮层，防止浮层带到下一个页面
        document.body.removeChild(toastElems[toastElems.length - 1]);
    }
    let loadingElems = document.getElementsByClassName("nut-loading");
    if(loadingElems.length > 0){ //删除已经展示的loading，防止loading一直增多
        for(let item of loadingElems){
            document.body.removeChild(item);
        }
    }

    //进入路由首先清除轮询器和清除轮询的timer
    clearInterval(listener);
    clearTimeout(timer);

    //3.0.0以上版本,isHideHeader=true的隐藏h5返回头，其余的展示h5返回头
    if(router.app.isClientVersionHigher({androidVerCode: 23, iosVerCode: '3.0.0'})){
        // alert('3.0.0以上版本');
        //把是否展示返回头变量存入store，根据路由meta中的isHideHeader
        if(to.meta.isHideHeader){
            // alert('3.0.0以上隐藏header');
            // 判断是否在3.1.2以上版本原生头页面白名单中
            if (nativeType.NATIVEHEADPAGE.includes(to.path)) {
                if (
                    router.app.isClientVersionHigher({
                        androidVerCode: 28,
                        iosVerCode: '3.1.0',
                    })
                ) {
                    store.commit(commonType.SET_HIDE_HEADER, true)
                    //处理掉header第一个兄弟结点的margin-top
                    dealHeader()
                    if (
                        util.isAndroid() &&
                        window.JDWebView &&
                        window.JDWebView.asyncToNative
                    ) {

                        util.jumpToRN('setTitleRightIconAndRightView', '', {
                            iconType: 'default',
                            textType: 'default',
                            text: '',
                        })
                    } else if (util.isIOS() && window.webkit &&
                            window.webkit.messageHandlers) {
                        const setIconData = {
                            type: 'default',
                            text: '',
                        }
                        const setTextData = {
                            type: 'default',
                            text: '',
                        }
                        if (
                            window.webkit.messageHandlers.setTopBarTitleIcon &&
                            window.webkit.messageHandlers.setTopBarTitleIcon
                                .postMessage
                        ){
                            window.webkit.messageHandlers.setTopBarTitleIcon.postMessage(
                                JSON.stringify(
                                    setIconData
                                )
                            )
                        }

                        if (
                            window.webkit.messageHandlers
                                .setTopBarRightButton &&
                            window.webkit.messageHandlers.setTopBarRightButton
                               .postMessage
                        ) {
                            window.webkit.messageHandlers.setTopBarRightButton.postMessage(
                                JSON.stringify(
                                    setTextData
                                )
                            )
                        }

                    }
                } else {
                    store.commit(commonType.SET_HIDE_HEADER, false)
                }
            } else {
                store.commit(commonType.SET_HIDE_HEADER, true)
                //处理掉header第一个兄弟结点的margin-top
                dealHeader()
            }
        }else{
            // alert('3.0.0以上展示header');
            store.commit(commonType.SET_HIDE_HEADER, false);
        }
    }else{ //3.0.0及以下版本，展示返回头
        store.commit(commonType.SET_HIDE_HEADER, false);
        // alert('3.0.0及以下版本展示header');
    }

    window.scrollTo(0,0.1); //解决iOS页面返回白屏问题
})

export default router;




// WEBPACK FOOTER //
// ./src/router/index.js